var core = {
  format: {
    date: 'd.MM.yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },

  translation: {
    common: {
      about: 'About 4ga Boards',
      aboutShort: 'About',
      account: 'Account',
      activityBy: 'Activity by {{name}}',
      activityCreated: 'Created',
      activityFor: 'Activity for {{name}}',
      activityForComment: 'Activity for the comment by {{name}}',
      activityUpdated: 'Updated',
      addAttachment: 'Add attachment',
      addAttachmentButton: 'Add Attachment',
      addAttachmentExtra: '(Drop here, Ctrl+V or click to upload)',
      addBoard: 'Add Board',
      addCard: 'Add Card',
      addCardTooltip: 'Add card and open it: [Ctrl+Enter] or [Ctrl+Add Card Button]\nAdd multiple cards: [Shift+Enter] or [Shift+Add Card Button]',
      addComment: 'Add comment',
      addDescription: 'Add Description',
      addDueDate: 'Add Due Date',
      addLabel: 'Add Label',
      addList: 'Add List',
      addListTooltip: 'Add multiple lists: [Shift+Enter] or [Shift+Add List Button]',
      addManager_title: 'Add Manager',
      addMember: 'Add Member',
      addMember_title: 'Add Member',
      addMembers: 'Add Members',
      addProject: 'Add Project',
      addTask: 'Add Task',
      addUser: 'Add User',
      admin: 'Admin',
      all: 'All',
      allChangesWillBeAutomaticallySaved: 'All changes will be saved automatically once the connection is restored',
      allowedRegisterDomains: 'Allowed Registration Domains',
      allowedRegisterDomainsPlaceholder: 'example.com;example.org',
      anyDomain: 'Any Domain',
      anyMatch: 'Any Match [Alt+V]',
      apiClient: 'API Client',
      apiClients: 'API Clients',
      applyTheme: 'Override Custom Theme with {{theme}} Theme',
      areYouSureYouWantToDeleteThisApiClient: 'Are you sure you want to delete this API client?',
      areYouSureYouWantToDeleteThisAttachment: 'Are you sure you want to delete this attachment?',
      areYouSureYouWantToDeleteThisBoard: 'Are you sure you want to delete this board?',
      areYouSureYouWantToDeleteThisCard: 'Are you sure you want to delete this card?',
      areYouSureYouWantToDeleteThisComment: 'Are you sure you want to delete this comment?',
      areYouSureYouWantToDeleteThisLabel: 'Are you sure you want to delete this label?',
      areYouSureYouWantToDeleteThisList: 'Are you sure you want to delete this list?',
      areYouSureYouWantToDeleteThisProject: 'Are you sure you want to delete this project?',
      areYouSureYouWantToDeleteThisTask: 'Are you sure you want to delete this task?',
      areYouSureYouWantToDeleteThisUser: 'Are you sure you want to delete this user?',
      areYouSureYouWantToLeaveBoard: 'Are you sure you want to leave the board?',
      areYouSureYouWantToLeaveProject: 'Are you sure you want to leave the project?',
      areYouSureYouWantToRemoveThisManagerFromProject: 'Are you sure you want to remove this manager from the project?',
      areYouSureYouWantToRemoveThisMemberFromBoard: 'Are you sure you want to remove this member from the board?',
      attachment: 'Attachment',
      attachmentCount: 'Attachment Count',
      attachments: 'Attachments',
      authentication: 'Authentication',
      avatar: 'Avatar',
      avatarText: 'Profile picture',
      back: 'Back',
      background: 'Background',
      backToDashboard: 'Back to Dashboard',
      backToProject: 'Back to Project',
      beta: 'Beta',
      board: 'board',
      board_title: 'Board',
      boardNotFound_title: 'Board Not Found',
      boards: 'boards',
      boards_one: '{{count}} board',
      boards_other: '{{count}} boards',
      boards_title: 'Boards',
      boards_title_one: '{{count}} Board',
      boards_title_other: '{{count}} Boards',
      boardView: 'Board',
      canComment: 'Can comment',
      canEditContentOfBoard: 'Can edit the content of the board',
      cannotEditInstanceSettings: 'You are not authorized to edit instance settings!',
      cannotEditUsersSettings: 'You are not authorized to edit instance users!',
      canOnlyViewBoard: 'Can only view the board',
      card: 'card',
      card_title: 'Card',
      cardActions_title: 'Card Actions',
      cardDueDateSummary: 'The closest due date for card:',
      cardNotFound_title: 'Card Not Found',
      cards: 'cards',
      cards_one: '{{count}} card',
      cards_other: '{{count}} cards',
      cards_title: 'Cards',
      cards_title_one: '{{count}} Card',
      cards_title_other: '{{count}} Cards',
      checkActivity: 'Check Activity',
      checkUserAccountActivity: 'Check User Account Activity',
      clearFilter: 'Clear filter',
      clientId: 'Client Id',
      clientSecret: 'Client Secret',
      close: 'Close',
      closeCard: 'Close Card',
      closeDropdown: 'Close dropdown',
      closestDueDate: 'Earliest Due',
      collapseList: 'Collapse List',
      color: 'Color',
      colorName: 'Color Name',
      commentCount: 'Comment Count',
      comments: 'Comments',
      compact: 'Compact',
      connectedToGithub: 'Connected to GitHub: {{repo}}',
      connections: 'Edit GitHub Connection',
      connectToGithub: 'Connect to GitHub',
      copyClientId: 'Copy Client Id',
      copyClientSecret: 'Copy Client Secret',
      copyEmail: 'Copy Email',
      coverImage: 'Cover Image',
      created: 'Created',
      createdAt: 'Created At',
      createdAt_withDate: 'Created at {{date}}',
      createdBy: 'Created By',
      createdViaApi: 'Created via API',
      createLabel_title: 'Create Label',
      createTextFile_title: 'Create Text File',
      currentEmail: 'Email: <email>{{email}}</email> <status>({{status}})</status>',
      currentPassword: 'Current password',
      currentUsername: 'Username: <username>{{username}}</username>',
      currentValue: 'Current Value',
      customized: 'Customized',
      customTheme: 'Custom Theme',
      dangerZone_title: 'Danger Zone',
      dashboard: 'Dashboard',
      date: 'Date',
      default: 'Default',
      defaultView: 'Default View',
      deleteAll: 'Delete All',
      deleteAllRead: 'Delete All Read',
      deleteApiClient: 'Delete API Client',
      deleteAttachment_title: 'Delete Attachment',
      deleteBoard_title: 'Delete Board',
      deleteCard_title: 'Delete Card',
      deleteComment: 'Delete Comment',
      deleteComment_title: 'Delete Comment',
      deleteEmail: 'Delete Email',
      deleteEmail_withEmail: 'Delete email {{email}}',
      deleteEmailConfirmation: 'Are you sure you want to delete this email?',
      deleteLabel_title: 'Delete Label',
      deleteList_title: 'Delete List',
      deleteProject_title: 'Delete Project',
      deleteTask_title: 'Delete Task',
      deleteUser_title: 'Delete User',
      demoMode: 'Demo Mode',
      demoModeExplanation: 'Demo Mode - some features affecting other users are disabled! Every new user receives admin privileges.',
      demoModeGithubExtra: 'Your support speeds up development',
      demoModeGithubMain: 'Star 4ga Boards on GitHub!',
      description: 'Description',
      descriptionAllowedRegisterDomains: 'Semicolon separated list of allowed email domains for user registration. Leave empty to allow any domain.',
      descriptionCompactSidebar: 'This option makes the sidebar narrower.',
      descriptionCustomTheme: 'Edit your custom themes in the Theme Editor.',
      descriptionDefaultView: 'Select the default view when opening the board.',
      descriptionEmailNotificationsDeliveryMode: 'Select the delivery mode for email notifications.',
      descriptionEmailNotificationsEnabled: 'Enable or disable receiving email notifications.',
      descriptionEmailNotificationsMarkReadAsDelivered: 'Prevents sending email notifications if the notification was already read in the app before delivery',
      descriptionEmailNotificationsTypes: 'Select the types of notifications you want to receive via email.',
      descriptionHideCardModalActivity: 'Hide created and updated in card modal.',
      descriptionHideClosestDueDate: 'Hide closest due date in card modal.',
      descriptionLanguage: 'Select the language you want to use in 4ga Boards.',
      descriptionListViewStyle: 'Select the list view style.',
      descriptionLocalRegistration: 'Enable or disable local user registration. This registration method allows users to create an account with a username and password.',
      descriptionNotificationTypes: 'Select the types of notifications you want to receive.',
      descriptionPreferredDetailsFont: 'Select the font you want to use in card description and comments.',
      descriptionProjectCreationAll: 'Enable or disable project creation for all users. If you disable project creation for all users, only admins will be able to create new projects.',
      descriptionSsoRegistration: 'Enable or disable SSO user registration. This registration method allows users to create an account using an external account e.g. Google Account.',
      descriptionSubscribeToInstance: 'Automatically subscribe to the instance notifications (admin only).',
      descriptionSubscribeToNewBoards: 'Automatically subscribe to boards I join.',
      descriptionSubscribeToNewProjects: 'Automatically subscribe to projects I join.',
      descriptionSubscribeToOwnCards: 'Automatically subscribe to cards I create.',
      descriptionSubscribeToUsers: 'Automatically subscribe to users notifications (admin only).',
      descriptionSyncSsoAdminOnAuth: 'Enable or disable synchronization of admin from the SSO provider during authentication. Enabling this option can automatically grant or revoke admin rights based on the SSO data.',
      descriptionSyncSsoDataOnAuth: 'Enable or disable synchronization of user data from the SSO provider during authentication.',
      descriptionTheme: 'Select the color theme of the application.',
      descriptionThemeShape: 'Select the shape of the application theme.',
      descriptionUserRegistration: 'Enable or disable all user registration methods. If you disable all registration methods, only admins will be able to create new users.',
      descriptionUsersSettingsStyle: 'Select the style of the users settings.',
      detailsAttachments_one: 'This card has {{count}} attachment',
      detailsAttachments_other: 'This card has {{count}} attachments',
      detailsComments_one: 'This card has {{count}} comment',
      detailsComments_other: 'This card has {{count}} comments',
      detailsDescription: 'This card has a description',
      detailsNotifications_one: 'This card has {{count}} notification',
      detailsNotifications_other: 'This card has {{count}} notifications',
      detectAutomatically: 'Detect automatically',
      disabled: 'Disabled',
      docs: 'Documentation',
      done: 'Done',
      dropFileToUpload: 'Drop files to upload',
      dueDate_title: 'Due Date',
      dueDateSummary: 'Closest due date for unfinished task:',
      duplicateTask: 'Duplicate Task',
      editAllowedRegisterDomains: 'Edit Allowed Registration Domains',
      editApiClient: 'Edit API Client',
      editAttachment: 'Edit Attachment',
      editAttachment_title: 'Edit Attachment',
      editAttachmentName: 'Edit Attachment Name',
      editAvatar_title: 'Edit Avatar',
      editBoard_title: 'Edit Board',
      editCard: 'Edit Card',
      editComment: 'Edit Comment',
      editDescription: 'Edit Description',
      editDueDate: 'Edit Due Date',
      editDueDate_title: 'Edit Due Date',
      edited: 'Edited',
      editEmail_title: 'Edit Email',
      editInformation_title: 'Edit Information',
      editLabel: 'Edit Label',
      editLabel_title: 'Edit Label',
      editLabels: 'Edit Labels',
      editList: 'Edit List',
      editListView: 'Edit List View',
      editMembers: 'Edit Members',
      editor: 'Editor',
      editPassword_title: 'Edit Password',
      editPermissions_title: 'Edit Permissions',
      editProject: 'Edit Project',
      editTask: 'Edit Task',
      editTimer: 'Edit Timer',
      editTimer_title: 'Edit Timer',
      editUser: 'Edit User',
      editUsername_title: 'Edit Username',
      email: 'Email',
      emailCardToBoard: 'Email Card to Board',
      emailCardToBoard_withCount: 'Email Card to Board <count>({{count}})</count>',
      emailCardToList: 'Email Card to List',
      emailCardToList_withCount: 'Email Card to List <count>({{count}})</count>',
      emailNotifications: 'Email Notifications',
      emailNotificationsDeliveryMode: 'Email Notifications Delivery Mode',
      emailNotificationsDeliveryModeBatched: 'Batched',
      emailNotificationsDeliveryModeInstant: 'Instant',
      emailNotificationsDeliveryModeInstantThenBatched: 'Instant then Batched',
      emailNotificationsEnabled: 'Email Notifications Enabled',
      emailNotificationsMarkReadAsDelivered: 'Skip Emails for Read Notifications',
      emailNotificationsTypes: 'Email Notifications Types',
      emailServiceUnavailable: 'Email service is unavailable. Contact 4ga Boards instance admin.',
      emailVerification: 'Email Verification',
      emailVerificationFailure_title: 'Email Verification Failed',
      emailVerificationSuccess_title: 'Email Verified Successfully',
      empty: 'Empty',
      enabled: 'Enabled',
      enableLocalRegistration: 'Local User Registration',
      enableProjectCreationAll: 'Project Creation For All Users',
      enableRegistration: 'User Registration',
      enableSsoRegistration: 'SSO User Registration',
      enterAttachmentName: 'Enter attachment name...',
      enterBoardName: 'Enter board name...',
      enterCardName: 'Enter card name...',
      enterCardNameWithHint: 'Enter card name... [Ctrl+Enter] - open',
      enterComment: 'Enter comment...',
      enterDescription: 'Enter description...',
      enterDueDate: 'Enter due date...',
      enterFileName: 'Enter file name...',
      enterGithubRepository: 'Enter GitHub repository... <Owner/Repo>',
      enterLabelName: 'Enter label name...',
      enterListName: 'Enter list name...',
      enterProjectName: 'Enter project name...',
      enterTaskDescription: 'Enter task description...',
      excludingNonMembershipProjects: "(excluding projects you're not a part of)",
      expandList: 'Expand List',
      exportBoard_title: 'Export Board',
      exportBoardExplanation: 'Your download will start automatically, when the export is ready.',
      exportSkipActions: 'Skip actions (history)',
      exportSkipAttachments: 'Skip attachments',
      exportSkipMetadata: 'Skip metadata',
      exportSkipProjectBackgrounds: 'Skip project backgrounds',
      exportSkipUserAvatars: 'Skip user avatars',
      facebook: 'Facebook',
      feedbackExtra: 'It means a lot for us',
      feedbackMain: "We'd love to hear your feedback!",
      fetching: 'Fetching...',
      filterBoards: 'Filter boards...',
      filterByAggregated: 'Filter by Project/Board/User/Card/Text/Activity Type...',
      filterByBoard: 'Filter by Board...',
      filterByCard: 'Filter by Card...',
      filterByDueDate_title: 'Filter by Due Date',
      filterByLabels_title: 'Filter By Labels',
      filterByMembers_title: 'Filter By Members',
      filterByNotifications_title: 'Filter by Notifications',
      filterByProject: 'Filter by Project...',
      filterByText: 'Filter by Text/Activity Type...',
      filterByUser: 'Filter by User...',
      filterCards: 'Filter cards...',
      filterEmailsByUser: 'Filter emails by user...',
      filterIdAggregated: 'Aggregated',
      filterIdBoard: 'Board',
      filterIdCard: 'Card',
      filterIdProject: 'Project',
      filterIdText: 'Text',
      filterIdUser: 'User',
      filterProjects: 'Filter projects...',
      firstPage: 'First Page',
      from4gaBoards: 'From 4ga Boards',
      fromTrello: 'From Trello',
      general: 'General',
      generate: 'Generate',
      generateApiClient: 'Generate API Client',
      generateNewEmail: 'Generate New Email',
      generating: 'Generating...',
      github: 'GitHub',
      goToThemeEditor: 'Go to Theme Editor',
      hasDescription: 'Has Description',
      hideBoards: 'Hide boards',
      hideCardModalActivity: 'Hide Card Modal Activity',
      hideClosestDueDate: 'Hide Closest Due Date',
      hideSidebar: 'Hide Sidebar',
      hideTasks: 'Hide Tasks',
      hours: 'Hours',
      ideas: 'Open',
      importBoard_title: 'Import Board',
      importGettingStartedProject: 'Import Getting Started Project',
      importNonExistingUsers: 'Create accounts for non-existing users',
      importProjectManagers: 'Add project managers',
      inProgress: 'In Progress',
      instanceSettings: 'Instance Settings',
      justSelectedDay: 'Show Cards Just For Selected Day',
      kanban: 'Kanban',
      labels: 'Labels',
      language: 'Language',
      lastLogin: 'Last login',
      lastPage: 'Last Page',
      lastUsed: 'Last used:',
      latestVersion: 'Latest version:',
      leaveBoard_title: 'Leave Board',
      leaveProject_title: 'Leave Project',
      linkCard: 'Copy Link',
      linkedin: 'LinkedIn',
      list: 'List',
      listActions_title: 'List Actions',
      listView: 'List',
      listViewStyle: 'List View Style',
      mailAuthor: 'Mail Author',
      mailToCardSyntax: 'To add a card via email, send an email to the generated email address\nEmail subject may contain:\n- card name (required)\n- username e.g. @john\n- label e.g. #important\n- due date e.g. !2027-12-31\n\nEmail body may contain:\n- description\n- attachments (pasted/attached files)\n- task lists e.g.\n - [ ] Task 1\n - [x] Task 2\nEach task supports adding members and due dates in the same way as in subject.',
      managers: 'Managers',
      markAllAsRead: 'Mark All as Read',
      markAllAsUnread: 'Mark All as Unread',
      markAsCompleted: 'Mark task as completed',
      markAsUncompleted: 'Mark task as uncompleted',
      matchCase: 'Match Case [Alt+C]',
      members: 'Members',
      minutes: 'Minutes',
      modifySettings: 'Modify Settings',
      monospace: 'Monospace',
      moveCard_title: 'Move Card',
      moveCardToList: 'Move Card To List',
      name: 'Name',
      needInvite: 'No Projects Available - Ask for an invitation.',
      never: 'Never',
      newEmail: 'New e-mail',
      newPassword: 'New password',
      newUsername: 'New username',
      nextPage: 'Next Page',
      noApiClients: 'No API Clients',
      noBoards: 'No boards',
      noConnection: "No connection - Please don't reload the tab!",
      noEmails: 'No emails',
      noLists: 'No lists',
      noLongerBoardMember: 'This user is no longer a member of this board!',
      noLongerProjectMember: 'This user is no longer a member of this project!',
      noProjects: 'No projects',
      notConnectedToGithub: 'Not connected to GitHub',
      notificationActions: 'Notification Actions',
      notifications: 'Notifications',
      notificationsWithCount: 'Notifications <count>({{unread}}/{{total}})</count>',
      notificationTypes: 'Notification Types',
      notSet: 'not set',
      notVerified: 'not verified',
      noUnreadNotifications: 'No unread notifications',
      ofBoards_one: '{{filteredCount}} of {{count}} board',
      ofBoards_other: '{{filteredCount}} of {{count}} boards',
      ofCards_one: '{{filteredCount}} of {{count}} card',
      ofCards_other: '{{filteredCount}} of {{count}} cards',
      ofNotifications_one: '{{filteredCount}} of {{count}} notification',
      ofNotifications_other: '{{filteredCount}} of {{count}} notifications',
      ofProjects_one: '{{filteredCount}} of {{count}} project',
      ofProjects_other: '{{filteredCount}} of {{count}} projects',
      openDropdown: 'Open dropdown',
      openNotificationCenter: 'Open Notification Center',
      optional_inline: 'optional',
      or: 'or',
      organization: 'Organization',
      permissions: 'Permissions',
      perPage: 'per page',
      phone: 'Phone',
      pleaseTryAgain: 'Please try again!',
      preferences: 'Preferences',
      preferredDetailsFont: 'Preferred Details Font',
      previousPage: 'Previous Page',
      profile: 'Profile',
      profileAndSettings: 'Profile and Settings',
      project: 'project',
      project_title: 'Project',
      projectNotFound_title: 'Project Not Found',
      projects: 'projects',
      projects_one: '{{count}} project',
      projects_other: '{{count}} projects',
      projects_title: 'Projects',
      projects_title_one: '{{count}} Project',
      projects_title_other: '{{count}} Projects',
      projectSettings: 'Project Settings',
      reason: 'Reason: {{reason}}',
      regenerateSecret: 'Regenerate Secret',
      removeManager_title: 'Remove Manager',
      removeMember_title: 'Remove Member',
      renameBoard: 'Rename Board',
      renameProject: 'Rename Project',
      reorderBoards: 'Reorder boards within the project',
      requiresAdminRights: '(requires admin rights)',
      requiresEmailVerification: '(requires email verification)',
      resendVerificationEmail_title: 'Resend Verification Email',
      resetApiClient: 'Reset API Client',
      resetColumnFilters: 'Reset Column Filters',
      resetColumnSorting: 'Reset Column Sorting',
      resetColumnVisibility: 'Reset Column Visibility',
      resetColumnWidths: 'Adjust Columns to Fit Content',
      resetColumnWidthsFitScreen: 'Adjust Columns to Fit Screen',
      resetEmail: 'Reset Email',
      resizeColumn: 'Resize column',
      save: 'Save',
      searchLabels: 'Search labels or create one...',
      searchMembers: 'Search members...',
      searchUsers: 'Search users...',
      seconds: 'Seconds',
      secret: 'API Client Secret',
      secretDisclaimer: 'Please copy and save the API Client Secret.<br>It will be visible only during this session.',
      selectAll: 'Select All',
      selectBoard: 'Select board',
      selectColor: 'Select Color',
      selectColumns: 'Select Columns',
      selectDefault: 'Select Default',
      selectList: 'Select list',
      selectNone: 'Select None',
      selectPermissions_title: 'Select Permissions',
      selectProject: 'Select project',
      setPassword_title: 'Set Password',
      settings: 'Settings',
      settingsAbout: 'Settings: About',
      settingsAccount: 'Settings: Account',
      settingsAuthentication: 'Settings: Authentication',
      settingsInstance: 'Settings: Instance',
      settingsPreferences: 'Settings: Preferences',
      settingsPreferencesTheme: 'Settings: Theme Editor',
      settingsProfile: 'Settings: Profile',
      settingsProject: 'Settings: Project',
      settingsUsers: 'Settings: Users',
      showBoards: 'Show boards',
      showing: 'Showing',
      showSidebar: 'Show Sidebar',
      showTasks: 'Show Tasks',
      sidebarCompact: 'Compact Sidebar',
      simple: 'Simple',
      ssoGithubEmail: 'GitHub Email',
      ssoGithubUsername: 'GitHub Username',
      ssoGoogleEmail: 'Google Email',
      ssoMicrosoftEmail: 'Microsoft Email',
      ssoOidcEmail: 'OIDC Email',
      startTimer: 'Start Timer',
      stopTimer: 'Stop Timer',
      subscribed: 'Subscribed',
      subscribeToInstance: 'Subscribe to instance notifications',
      subscribeToNewBoards: 'Subscribe to new boards',
      subscribeToNewProjects: 'Subscribe to new projects',
      subscribeToOwnCards: 'Subscribe to my own cards',
      subscribeToUsers: 'Subscribe to users notifications',
      supportDevelopment: 'Support 4ga Boards Development',
      switchToBoardView: 'Switch to Board View',
      switchToListView: 'Switch to List View',
      syncSsoAdminOnAuth: 'Sync SSO Admin on Authentication',
      syncSsoDataOnAuth: 'Sync SSO Data on Authentication',
      taskActions_title: 'Task Actions',
      tasks: 'Tasks',
      template: 'Template',
      theme: 'Theme',
      themeCustom: 'Custom',
      themeDefault: 'Default',
      themeEditor: 'Theme Editor',
      themeGithubDark: 'GitHub Dark',
      themeLight: 'Light',
      themeShape: 'Theme Shape',
      themeShapeDefault: 'Default',
      themeShapeRounded: 'Rounded',
      thereIsNoPreviewAvailableForThisAttachment: 'There is no preview available for this attachment',
      time: 'Time',
      timer: 'Timer',
      todo: 'Todo',
      toggleItem: 'Toggle {{item}}',
      toggleNotificationFilter: 'Toggle notification filter: aggregated/project/board/user/card/text [Tab]',
      toggleSidebarFilter: 'Toggle filter: boards/projects [Tab]',
      toTest: 'To Test',
      unableToFetch: 'Unable to fetch',
      unsavedChanges: 'Local changes',
      updated: 'Updated',
      updatedAt: 'Updated At',
      updatedAt_withDate: 'Updated at {{date}}',
      updatedBy: 'Updated By',
      userAccountNotifications: 'User Account Notifications',
      userActions_title: 'User Actions',
      userAvatar: 'User Avatar',
      username: 'Username',
      users: 'Users',
      usersSettingsStyle: 'Users Settings Style',
      value: 'Value',
      verified: 'verified',
      version: 'Version:',
      viewer: 'Viewer',
      website: 'Website',
      writeComment: 'Write a comment...',
      writeCommentHint: '[Ctrl+Enter] - submit',
      x: 'X',
      you: '(You)',
      youtube: 'YouTube',
    },
  },
};

export { core as default };
